import * as ex from "excalibur";
import { Resources } from "../Resources";
import { Player } from "../player";
import { Grandpa } from "../actors/characters/grandpa";
import { hiveState, playerState } from "../state/stateManager";
import { Hive } from "../actors/hive";
import Dialog from "../ui/dialog";
import getDialogText from "../content/npcContent";
import { goToScene } from "../main";
import HoneyStand from "../actors/honeyStand";

export class HomeIntro extends ex.Scene {
  constructor() {
    super();

    this.honeyStand = new HoneyStand({ x: 24 * 16 - 5, y: 23 * 16 + 8 }, this);
    this.honeyStand.z = 10;
    this.actorsDead = false;
    this.content = playerState.getContent();
    this.grandpaComplete = false;
  }
  setActors() {
    const player = new Player(20 * 16, 21 * 16);
    this.player = player;
    this.player.z = 3;
    this.player.wearingVeil = false;
    this.player.lastDir = "up";
    const grandpa = new Grandpa(13 * 16, 14 * 16);
    this.grandpa = grandpa;
    this.grandpa.z = 10;
    this.add(this.player);
    this.add(this.grandpa);
    this.camera.strategy.lockToActor(this.grandpa);
    this.camera.zoom = 1;
    this.player.cutScene = true;
    this.grandpa.cutScene = true;
    setTimeout(() => {
      this.camera.zoomOverTime(1.4, 2000);
      this.startScene();
    }, 1000);
  }
  onActivate() {
    this.setActors();
  }
  onDeactivate() {
    this.actorsDead = true;
    this.grandpa.kill();
    this.player.kill();
    this.grandpa.actions.clearActions();
  }
  onInitialize(engine) {
    let cutScene = document.getElementById("cutSceneText");
    cutScene.style.display = "none";
    Resources.TiledMap.addToScene(this);
    Resources.AppleCider.play(0.2);
    Resources.AppleCider.loop = true;

    this.add(this.honeyStand);
    // this.player = Resources.TiledMap.getObjectsByName("player");

    const map_bounds = ex.BoundingBox.fromDimension(
      Resources.TiledMap.map.width * Resources.TiledMap.map.tilewidth + 10,
      Resources.TiledMap.map.height * Resources.TiledMap.map.tileheight + 10,
      ex.Vector.Zero,
      Resources.TiledMap.pos
    );
    this.camera.strategy.limitCameraBounds(map_bounds);

    this.door = new ex.Trigger({
      pos: new ex.Vector(8 * 16, 10 * 16 + 8),
      width: 16,
      height: 16,
      visible: true,
      target: this.player,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        console.log("collided with trigger");
        goToScene("house");
      },
    });
    this.add(this.door);

    const hives = hiveState.getHives();

    for (let i = 0; i < hives.length; i++) {
      this.add(new Hive(hives[i].position.x, hives[i].position.y, hives[i]));
    }
  }
  startScene() {
    this.dialogText = getDialogText();
    this.grandpa.actions.clearActions();
    this.grandpa.actions
      .callMethod(() => {
        console.log("calling grandpagraphics");
        this.grandpa.graphic = "down-walk";
      })
      .moveTo(19 * 16, 19 * 16, 20)
      .callMethod(() => {
        console.log("calling grandpagraphics");
        this.grandpa.graphic = "down-idle";
        this.grandpaComplete = true;
      });
    this.introGreeting = new Dialog(
      this.dialogText.grandpa.firstIntro,
      () => {
        //ended
        // this.player.cutScene = false;
        this.grandpa.actions
          .callMethod(() => {
            this.grandpa.graphic = "up-walk";
          })
          .moveTo(7 * 16, 10 * 16, 30)
          .callMethod(() => {
            this.grandpa.kill();
          });
        this.player.actions
          .callMethod(() => {
            this.player.playingAnim = true;
            this.player.anim = "up-walk";
          })
          .moveTo(7 * 16, 10 * 16, 30)
          .callMethod(() => {
            this.player.kill();
            goToScene("house");
          });
      },
      "grandpa",
      "top"
    );
  }
  onPostUpdate(engine) {
    if (engine.input.keyboard.wasPressed(ex.Keys.Enter)) {
      if (this.introGreeting && this.grandpaComplete) {
        this.introGreeting.enterPress();
      }
    }
  }
}
